<template>
	<div>
		<div class="ModalPrompt" >
			<h1>Change {{ dsplApostrophize(org.name) }} payment card</h1>
    </div>
		<div class="ModalBody">
      
      <AddOrUpdateSubscription
        v-if="org.subscription.subscribed"
        :org="org"
        :onSuccess="onSuccess"
      />
      <div v-else >
        <p>Your account is not activated yet!</p>
        <p><button class="btn-a" @click="toBilling()" >Go to billing page</button></p>
      </div>
    
		</div>
	</div>
</template>

<script>

	import AddOrUpdateSubscription from '../components/AddOrUpdateSubscription';

	export default {
    components : {AddOrUpdateSubscription},
    props : ['org'],
    
		methods: {
      toBilling(){
        Event.$emit('modal-close');
        this.$router.push({name:'org.billing',params:{org_id:this.org.id}});
      },
			onSuccess : function(payload){
        Event.$emit('modal-close');
      },

		}
	}
</script>